export default "__VITE_ASSET__Cjdkh$RZ__"